// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"3722":"8efaa5da1918ea07","3878":"37e1683448fc0db5","7361":"3bb79aa604713916","8433":"96af8a0c470a57e1"}[chunkId] + ".js";
};